export default __webpack_public_path__ + "update.c54fa0d6.svg";